import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PageHero, SectionHeader, SiteLayout } from "./components/SiteLayout";
import { caseStudies } from "./siteData";

const filterCategories = ["All Projects", "Software", "Hardware", "IT Solutions", "Volunteer"];

export default function ProjectsPage() {
  const [activeFilter, setActiveFilter] = useState("All Projects");

  const filtered = activeFilter === "All Projects"
    ? caseStudies
    : caseStudies.filter((s) => s.category === activeFilter);

  return (
    <SiteLayout title="Projects" description="Examples of software, hardware, and systems work by SaskTech Lab.">
      <PageHero
        eyebrow="Our Projects"
        title="Innovative solutions delivered by our talented teams under expert guidance."
        description="At SaskTech Lab, we take pride in the diverse range of projects we've successfully delivered across software, hardware, and IT domains. Each project represents not only a solution for our clients but also a learning opportunity for our team members."
        actions={[
          <Link key="contact" to="/contact" className="button-tertiary">
            Discuss a similar project
          </Link>,
        ]}
      />

      <section className="site-shell section-space pb-10">
        <SectionHeader eyebrow="Our Work" title="Projects that deliver results and build talent." description="Our portfolio includes both commercial projects for businesses and volunteer initiatives that support community needs." />

        <div className="mt-8 flex flex-wrap gap-3">
          {filterCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveFilter(cat)}
              className={`rounded-full px-5 py-2 text-sm font-semibold transition ${
                activeFilter === cat
                  ? "bg-emerald-900 text-white"
                  : "bg-emerald-50 text-emerald-900 hover:bg-emerald-100"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="mt-8 grid gap-6 xl:grid-cols-3">
          {filtered.map((study) => (
            <article key={study.title} className="panel-card flex h-full flex-col">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700">{study.sector}</p>
              <h3 className="mt-3 font-display text-2xl font-bold text-emerald-950">{study.title}</h3>
              <p className="mt-4 text-sm leading-7 text-slate-600">{study.summary}</p>
              <ul className="mt-6 space-y-3 text-sm text-slate-600">
                {study.results.map((result) => (
                  <li key={result} className="list-bullet-item">{result}</li>
                ))}
              </ul>
              <div className="mt-auto pt-6 flex flex-wrap gap-2">
                {study.stack.map((tech) => (
                  <span key={tech} className="chip-tag">
                    {tech}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="site-shell section-space pb-10">
        <div className="rounded-[36px] border border-emerald-900/10 bg-gradient-to-br from-white via-emerald-50 to-emerald-100 p-8 text-center lg:p-10">
          <h2 className="font-display text-3xl font-bold text-emerald-950">Ready to Work With Us?</h2>
          <p className="mt-4 text-base text-slate-600">Let us discuss how our team can help bring your project to life.</p>
          <div className="mt-8">
            <Link to="/contact" className="button-tertiary">Submit Your Project</Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
